<app-discard></app-discard>
<app-hand></app-hand>